<template>
  <div id="about">
    <div class="about__container">
      <div>
        <div class="about__card">
          <div class="about__image"></div>
        </div>
      </div>

      <div>
        <div class="about__title">Wein…</div>
        <div
          class="about__subtitle"
        >… damit verbinde ich Genuss und Lebensfreude, malerische Landschaften, den fruchtig-würzigen Duft reifer Weintrauben, Arbeit in und mit der Natur, Geselligkeit und spannende Geschichten, die das Winzerleben schreibt.</div>
        <div
          class="about__text"
        >Meine Leidenschaft gilt seit langem dem edlen Rebensaft. Am Deutschen Weininstitut konnte ich in diversen Seminaren meinen Wissenshorizont zum Thema Wein erweitern und so bekam ich von einer der größten Weinhandlungen Süddeutschlands, Vinopolis in Augsburg, die Chance, mein Hobby zum Beruf zu machen; diese habe ich gerne genutzt und weiter ausgebaut. Da mein zweites Hobby dem Reisen gilt war die Idee geboren, beides zu verbinden. Daraus entstand AUSZEIT … Endlich konnte ich meine vielen Ideen von kombinierten Weinreisen, die mir schon seit langem im Kopf herumschwirrten, verwirklichen. Wein ist so vielfältig, dass man ihn nicht auf ein Thema reduzieren darf. Ob in Verbindung mit Wellness, Natur, Wissen, Kochen, Kultur oder Nachhaltigkeit – Wein passt immer! Es ist mein täglicher Anspruch für jeden Geschmack ein unvergessliches Weinerlebnis zusammenzustellen und mit Ihnen zusammen zu erleben. Probieren Sie es aus, ich freue mich auf Sie.</div>
        <div class="about__signature"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<style scoped lang="scss">
#about {
  min-height: calc(100vh - 64px);
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(
    to bottom,
    #f0f0f0 61%,
    rgba(247, 247, 247, 0)
  );
  background-size: 100% 512px;
}

.about__container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 60px 48px;
}

.about__card {
  width: 352px;
  border-radius: 16px;
  box-shadow: 0 0 28px -8px rgba(13, 13, 13, 0.1),
    0 56px 100px -56px rgba(13, 13, 13, 0.2);
  background-color: #ffffff;
  padding: 16px 16px 48px;
  margin-right: 88px;
}

.about__image {
  width: 100%;
  height: 432px;
  background: url("../assets/img/mirjam-portrait.jpg");
  background-size: cover;
  border-radius: 4px;
}

.about__title {
  line-height: 32px;
  font-family: "Playfair Display";
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #0d0d0d;
  margin-bottom: 16px;
}

.about__subtitle {
  max-width: 552px;
  line-height: 23px;
  ////font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-family: Lato;
  font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.23px;
  color: #0d0d0d;
  margin-bottom: 16px;
}

.about__text {
  max-width: 552px;
  ////font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-family: Lato;
  font-weight: 300;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #4d4d4d;
  margin-bottom: 16px;
}

.about__signature {
  width: 100px;
  height: 78px;
  background: url("../assets/img/signature.png");
  background-size: cover;
}

@media (max-width: 1023px) {
  .about__container {
    flex-direction: column;
  }

  .about__card {
    width: 100%;
    margin-right: 0;
    max-width: 552px;
    margin-bottom: 60px;
  }

  .about__image {
    height: unset;
    padding-top: 85%;
    background-position: center center;
  }
}

@media (max-width: 767px) {
  .about__container {
    margin: 0 0 60px;
  }

  .about__card {
    max-width: unset;
    padding: 0;
    border-radius: 0;
    margin-bottom: 32px;
  }

  .about__image {
    border-radius: 0;
  }

  .about__title {
    margin: 0 24px 16px;
  }

  .about__subtitle {
    margin: 0 24px 16px;
  }

  .about__text {
    max-width: unset;
    margin: 0 24px 16px;
  }

  .about__signature {
    max-width: unset;
    margin: 0 24px 16px;
  }
}
</style>
